import { PickItemInterceptor, PickerService, PickServiceInterceptor } from "@visactor/vrender-core/picker/constants";

import { createContributionProvider } from "../common/explicit-binding";

import { DefaultMathPickerService } from "./math-picker-service";

import { bindMathPickerContribution } from "./contributions/math-picker/module";

import { MathPickerContribution } from "./contributions/constants";

import { bindArcMathPickerContribution } from "./contributions/math-picker/arc-module";

import { bindAreaMathPickerContribution } from "./contributions/math-picker/area-module";

import { bindCircleMathPickerContribution } from "./contributions/math-picker/circle-module";

import { bindGlyphMathPickerContribution } from "./contributions/math-picker/glyph-module";

import { bindImageMathPickerContribution } from "./contributions/math-picker/image-module";

import { bindLineMathPickerContribution } from "./contributions/math-picker/line-module";

import { bindPolygonMathPickerContribution } from "./contributions/math-picker/polygon-module";

import { bindPathMathPickerContribution } from "./contributions/math-picker/path-module";

import { bindRectMathPickerContribution } from "./contributions/math-picker/rect-module";

import { bindRichTextMathPickerContribution } from "./contributions/math-picker/richtext-module";

import { bindSymbolMathPickerContribution } from "./contributions/math-picker/symbol-module";

import { bindTextMathPickerContribution } from "./contributions/math-picker/text-module";

export function bindMathPicker(c) {
    c.isBound(DefaultMathPickerService) || c.bind(DefaultMathPickerService).toDynamicValue((() => new DefaultMathPickerService(createContributionProvider(MathPickerContribution, c), createContributionProvider(PickItemInterceptor, c), createContributionProvider(PickServiceInterceptor, c)))).inSingletonScope(), 
    c.isBound(PickerService) ? c.rebind(PickerService).toService(DefaultMathPickerService) : c.bind(PickerService).toService(DefaultMathPickerService);
}

export function loadMathPicker(c) {
    bindMathPickerContribution(c), bindMathPicker(c), bindArcMathPickerContribution(c), 
    bindAreaMathPickerContribution(c), bindCircleMathPickerContribution(c), bindGlyphMathPickerContribution(c), 
    bindImageMathPickerContribution(c), bindLineMathPickerContribution(c), bindPolygonMathPickerContribution(c), 
    bindPathMathPickerContribution(c), bindRectMathPickerContribution(c), bindRichTextMathPickerContribution(c), 
    bindSymbolMathPickerContribution(c), bindTextMathPickerContribution(c);
}
//# sourceMappingURL=math-module.js.map